import React from 'react';
import useDecisionTreeContext from '../../Contexts/DecisionTree/DecisionTreeContext/useDecisionTreeContext';

export default function useResizeWindow(sessionInProgress: boolean) {
  const { isMounted } = useDecisionTreeContext();
  const decisionTreeMounted = isMounted === 'split';

  React.useEffect(() => {
    const storedValue = localStorage.getItem('layout.decisionTreeMounted');
    if (storedValue) {
      if (storedValue !== decisionTreeMounted.toString()) {
        if (decisionTreeMounted) {
          window.resizeBy(0, window.innerHeight - 106);
        } else {
          window.resizeBy(0, -(window.innerHeight - 106) / 2);
        }
      }
    }
    localStorage.setItem('layout.decisionTreeMounted', decisionTreeMounted.toString());
  }, [decisionTreeMounted]);

  React.useEffect(() => {
    const storedValue = localStorage.getItem('layout.sessionInProgress');
    if (storedValue) {
      if (storedValue !== sessionInProgress.toString()) {
        if (sessionInProgress) {
          window.resizeBy(270, 0);
        } else {
          window.resizeBy(-270, 0);
        }
      }
    }
    localStorage.setItem('layout.sessionInProgress', sessionInProgress.toString());
  }, [sessionInProgress]);
}
